// extracted by mini-css-extract-plugin
module.exports =  {"rating":"da51a739f7--rating--P_Mu1","title":"da51a739f7--title--cUoBV"};